import { collection } from "firebase/firestore";
import { db } from "src/features/firebase/firestore/utils";

const getStatusCollection = () => collection(db, "status");

export { getStatusCollection };
